import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import TextField from '@/modules/common/components/TextField';
import MaterialPagination from '@material-ui/lab/Pagination';
import '../styles/Pagination.scss';

const Pagination = (props) => {
    const urlSearchParams = new URLSearchParams(props.history.location.search);
    const [inputPage, setInputPage] = useState(props.currentPage);

    const changePage = (newPage) => {
        const page = parseInt(urlSearchParams.get('page'));
        if (page !== newPage) {
            setInputPage(newPage);
            urlSearchParams.set('page', newPage);
            props.history.push({search: urlSearchParams.toString()});
        }
    };

    const handleSubmit = (event) => {
        const newPage = inputPage;
        event.preventDefault();
        changePage(newPage);
    };

    const handleChange = (event, newPage) => {
        changePage(newPage);
    };

    return (
        <>{(props.totalPages > 1)
            ? <div className="pagination">
                <form id="form-pagination" onSubmit={handleSubmit}>
                    <TextField type="number" inputProps={{min: 1, max: props.totalPages}}
                               value={inputPage} onChange={(event) => setInputPage(event.target.value)}
                    />
                </form>
                <MaterialPagination className="pagination" shape="rounded"
                                    count={props.totalPages} onChange={handleChange} page={props.currentPage}
                />
            </div>
            : null
        }</>
    );
};

Pagination.propTypes = {
    currentPage: PropTypes.number,
    totalPages: PropTypes.number.isRequired,
};

Pagination.defaultProps = {
    currentPage: 1,
};

let Component = Pagination;
Component = withRouter(Component);

export default Component;
